import React from "react";
import { Grid, FormControl, TextField, Button, useTheme, Box } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import Searchicon from '@mui/icons-material/Search';

import { tokens } from "../../../theme/theme";

const DespatchPlanFilter = ({
    fromDate,
    toDate,
    onFromChange,
    onToChange,
    autoFocus = false,
    containerProps = {},
    searchCO,
    onCOChange,
    handleSearch,
}) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const dateFieldProps = {
        size: "small",
        variant: "standard",
        InputProps: {
            disableUnderline: true,
        },
        sx: {
            backgroundColor: "transparent",
            padding: 0,
            "& .MuiInputBase-root": {
                border: "none",
                paddingRight: "6px",
            },
            "& .MuiSvgIcon-root": {
                fontSize: "18px",
            },
        },
    };

    return (

        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                p: 1,
                // mb: 1,
                ml: 1.5,
                mr: 1.5,
                borderRadius: 2,
                backgroundColor: colors.primary[400],
                boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
            }}
        >

            <Grid
                container
                spacing={2}
                alignItems="center"
                // sx={{ padding: "5px 5px", backgroundColor: colors.primary[500] }}
                {...containerProps}
            >
                {/* justifyContent: "flex-end", */}

                {/* FROM DATE */}
                <Grid item>                  

                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            label="Plan From Date"
                            value={dayjs(fromDate)}
                            // onChange={(date) => handleDateFilterChange("from", date)}
                            onChange={onFromChange}
                           
                            format="DD-MMM-YYYY"
                            slotProps={{ textField: { size: "small",color:"secondary" } }}
                        />
                    </LocalizationProvider>
                </Grid>

                {/* TO DATE */}
                <Grid item>
                    
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            label="Plan To Date"
                            value={dayjs(toDate)}
                         
                            // onChange={(date) => handleDateFilterChange("from", date)}
                            onChange={onToChange}
                            format="DD-MMM-YYYY"
                            slotProps={{ textField: { size: "small" ,color:"secondary"} }}
                        />
                    </LocalizationProvider>
                </Grid>

                {/* CONO / DPNO */}
                <Grid item>
                    <TextField
                        // variant="outlined"
                        label="CONO / DPNO"
                        size="small"
                        value={searchCO}
                        name="cono"
                        onChange={onCOChange}
                        color="secondary"
                        placeholder="Enter No."
                        sx={{
                            backgroundColor: "transparent",
                            padding: 0,
                            "& .MuiInputBase-root": {
                                border: "none",
                                paddingRight: "6px",
                            },
                            "& .MuiSvgIcon-root": {
                                fontSize: "18px",
                            },
                        }}
                    />
                </Grid>

                {/* SEARCH BUTTON */}
                <Grid item>
                    <Button
                        variant="contained"
                        color="secondary"
                        size="small"
                        startIcon={<Searchicon />}
                        
                        sx={{
                             height: 34,
                            px: 2,
                            fontWeight: 600,
                            textTransform: "none",
                            borderRadius: 2,
                            boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                        }}
                        onClick={handleSearch}
                    >
                        Search
                    </Button>
                </Grid>

            </Grid>
        </Box>
    );
};

export default DespatchPlanFilter;
